import { useState } from 'react';

const SUBMIT_ENDPOINT =
  'https://4s515gmi1j.execute-api.us-west-1.amazonaws.com/default/sendEmailLambda';

/**
 * Stage 1 of the driver application: a short pre-qualification form.
 * The safety team reviews the submission and, on approval, the applicant
 * is emailed a private link to the full application
 * (public/driver-application.html, which is invitation-only).
 */
const ApplyPage = () => {
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    const f = e.target;
    setStatus('sending');
    try {
      const res = await fetch(SUBMIT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'prequalify',
          name: f.name.value.trim(),
          phone: f.phone.value.trim(),
          email: f.email.value.trim(),
          license_state: f.license_state.value.trim(),
          license_number: f.license_number.value.trim(),
          license_class: f.license_class.value,
          experience_years: f.experience_years.value.trim(),
          message: f.message.value.trim(),
        }),
      });
      if (!res.ok) throw new Error('Server responded with ' + res.status);
      setStatus('sent');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <section className="contact" style={{ paddingTop: '120px', minHeight: '80vh' }}>
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Drive For C.H.I.</span>
          <h2 className="section-title">Driver Application</h2>
          <p className="section-subtitle">
            Start by sending us your basic driver information. Our safety team will review it
            and email you a personal link to complete the full application.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-7" data-aos="fade-up">
            <div className="contact__card">
              {status === 'sent' ? (
                <div style={{ textAlign: 'center', padding: '32px 8px' }}>
                  <h5 className="contact__card-title">Thanks — we got your info!</h5>
                  <p className="contact__card-sub" style={{ marginTop: 12 }}>
                    Our safety team is reviewing your information. If you're a good fit, we'll
                    email you a personal link to the full driver application — usually within
                    one business day. A confirmation has been sent to your email.
                  </p>
                </div>
              ) : (
                <>
                  <h5 className="contact__card-title">Tell us about yourself</h5>
                  <p className="contact__card-sub">
                    Takes about 2 minutes. No documents needed at this step.
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="chi-label">Full Legal Name *</label>
                      <input type="text" className="chi-input" name="name" placeholder="Full name" required />
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="chi-label">Phone Number *</label>
                        <input type="tel" className="chi-input" name="phone" placeholder="(555) 000-0000" required />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="chi-label">Email Address *</label>
                        <input type="email" className="chi-input" name="email" placeholder="your@email.com" required />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label className="chi-label">License State *</label>
                        <input type="text" className="chi-input" name="license_state" placeholder="CA" required />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label className="chi-label">License Number *</label>
                        <input type="text" className="chi-input" name="license_number" placeholder="License #" required />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label className="chi-label">License Class *</label>
                        <select className="chi-input" name="license_class" required defaultValue="">
                          <option value="" disabled>Select…</option>
                          <option value="Class A">Class A</option>
                          <option value="Class B">Class B</option>
                          <option value="Class C">Class C</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="chi-label">Years of Commercial Driving Experience *</label>
                      <input type="text" className="chi-input" name="experience_years" placeholder="e.g. 5 years" required />
                    </div>
                    <div className="mb-4">
                      <label className="chi-label">Anything else we should know?</label>
                      <textarea className="chi-input" name="message" rows="3"
                        placeholder="Endorsements, availability, preferred routes… (optional)" />
                    </div>
                    {status === 'error' && (
                      <p style={{ color: '#b3432f', fontSize: 14, marginBottom: 14 }}>
                        Something went wrong sending your info. Please try again, or call us at
                        (559) 497-1301.
                      </p>
                    )}
                    <button type="submit" className="chi-btn" disabled={status === 'sending'}>
                      {status === 'sending' ? 'Sending…' : 'Submit My Info'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplyPage;
